import { HmacMD5, MD5, SHA1 } from "crypto-js";
import parseJwt, { getCurrentEmail, getEmail } from "./JwtParser";

export function getFromStorage(key: string) {
  var secretKey = getCurrentEmail();
  const itemStr = localStorage.getItem(
    HmacMD5("trendz_data_" + key, secretKey).toString()
  );

  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(
      HmacMD5("trendz_data_" + key, secretKey).toString()
    );
    return null;
  }
  return item.value;
}

export function saveToStorage(key: string, value: any, ttl: number) {
  var secretKey = getCurrentEmail();

  if (ttl == null) {
    ttl = 3000000;
  }
  const item = {
    value: value,
    expiry: new Date().getTime() + ttl,
  };

  localStorage.setItem(
    HmacMD5("trendz_data_" + key, secretKey).toString(),
    JSON.stringify(item)
  );
}

export function removeFromStorage(key: string) {
  var secretKey = getCurrentEmail();
  localStorage.removeItem(HmacMD5("trendz_data_" + key, secretKey).toString());
}
